<template>
  <div style="height: 100%">
    <div class="photos-pc-body">
      <div class="pc-body">
        <div class="title">{{ photos.title }}</div>
        <div class="content">
          <div class="left">
            <div class="group-title">{{ photos.title }}</div>
            <div class="group-item" v-for="(item) in photos.list" :key="item.group" @click="onChooseGroup(item)">
              <div :class="selectedGroup.group != item.group ? 'group-normal' : 'group-selected'">{{ item.group }}</div>
            </div>
          </div>
          <div class="right">
            <div class="right-title">{{ selectedGroup.group }}</div>
            <div class="equipment">
              <div class="equipment-title">{{ selectedGroup.info }}</div>
            </div>
            <!-- <div class="equipment" >
                <img class="equipment-image" :src="'static/photo/' + selectedGroup.dirPath + '/' + imagePath" v-for="imagePath in selectedPath" :key="imagePath"/>
              </div> -->
            <div class="equipment" v-for="(item) in selectedGroup.datalist" :key="item.title">
              <img class="equipment-image" :src="'static/photo/' + item.image" v-if="item.image.length > 0" />
              <div class="equipment-content" v-if="item.desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="photos-mobile-body">
      <div class="header" @click="showMobileMenu()">{{ selectedGroup.group }} <i class="el-icon-arrow-down"
          v-show="!isMobileMenuShow" /><i class="el-icon-arrow-up" v-show="isMobileMenuShow" /></div>
      <div v-if="isMobileMenuShow" class="header-menu">
        <div v-for="(item) in photos.list" :key="item.group" @click="onChooseGroup(item)" class="header-menu-item">
          <div :class="selectedGroup.group != item.group ? 'group-normal' : 'group-selected'">{{ item.group }}</div>
        </div>
      </div>
      <div class="photos-body">
        <div class="title">{{ photos.title }}</div>
        <div class="equipment">
          <div class="equipment-title">{{ selectedGroup.info }}</div>
        </div>
        <div class="equipment" v-for="item in selectedGroup.datalist" :key="item.image">
          <img class="equipment-image" :src="'static/photo/' + item.image" />
          <div class="equipment-content" v-if="item.desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurLan } from '@/util/tools'
import Axios from "axios"

export default {
  name: 'photos-page',
  data() {
    return {
      isMobileMenuShow: false,
      selectedGroup: [],
      photos: {
        title: "相册"
      },
      photoPath: null,
      selectedPath: null
    }
  },
  mounted() {
    var self = this
    Axios.get('static/photo/photolist.json')
      .then(res => {
        self.photoPath = res.data
        getCurLan().then(res2 => {
          self.photos = res2.photos
          self.selectedGroup = self.photos.list[0]
          self.selectedPath = self.photoPath[self.selectedGroup.dirPath]
        })
      })
  },
  methods: {
    onChooseGroup(item) {
      this.selectedGroup = item
      this.selectedPath = this.photoPath[this.selectedGroup.dirPath]
      if (this.isMobileMenuShow) {
        this.isMobileMenuShow = false
      }
    },
    showMobileMenu() {
      this.isMobileMenuShow = !this.isMobileMenuShow
    }
  }
}
</script>
<style lang='scss' src='../assets/styles/pc/photos-page.scss'></style>
<style lang='scss' src='../assets/styles/mobile/photos-page.scss'></style>


// WEBPACK FOOTER //
// src/components/Photos.vue